module.exports = __webpack_public_path__ + "static/img/beans.5c5955a4.png";